import { render, staticRenderFns } from "./zoneIndex.vue?vue&type=template&id=d080b8d6&scoped=true&"
import script from "./zoneIndex.vue?vue&type=script&lang=js&"
export * from "./zoneIndex.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d080b8d6",
  null
  
)

export default component.exports